'use client';

import { useEffect } from 'react';
import { useImageStateStore } from 'stores/express-designer';

interface SyncCartStateProps {
  articleIds: number[];
}

export function SyncCartState({ articleIds }: SyncCartStateProps) {
  const syncWithCartArticles = useImageStateStore(s => s.syncWithCartArticles);

  useEffect(() => {
    syncWithCartArticles(articleIds);
  }, [articleIds, syncWithCartArticles]);

  return null;
}
